export const FETCH_WELLNESS_GOAL = 'FETCH_WELLNESS_GOAL';
export const FETCH_WELLNESS_GOAL_FETCHING = 'FETCH_WELLNESS_GOAL_FETCHING';
export const FETCH_WELLNESS_GOAL_SUCCESS = 'FETCH_WELLNESS_GOAL_SUCCESS';
export const FETCH_WELLNESS_GOAL_FAIL = 'FETCH_WELLNESS_GOAL_FAIL';
